import { activityFetch as fetch } from '../../components/feedback/requestActivity'
import { titleTheme, pageTheme, headerTheme } from '../../components/consoleTheme'
import NodeSetupGuide from '../../components/NodeSetupGuide'
import React, { useEffect, useState } from 'react';
import logo112 from '../../../src/resource/image/logo112.png';
import logo111 from '../../resource/image/logo111.png';
import ServiceInstaller from '../../ServiceInstaller.msi';
import RemoteCard from '../../components/RemoteCard';
import projectLogo from '../../resource/image/projectlogo.png';
import { useRecoilState } from 'recoil';
import { InfraListAtom } from '../../atoms/standardModelAtom';
import { reqGet } from '../../Service';
import { PopupAtom } from '../../atoms/popupAtom';
import Popup from '../../atoms/popupAtom';
import styled from "styled-components"
import { Search, ChevronDown, Plus } from "lucide-react"
import HostAddEditModal from '../../components/HostAddEditModal';
import ExternalCloud, {providerLabel} from './ExternalCloud';



// 클라이언트 설치 배너
export const InstallBanner = styled.div`
  &&{position:static;background:#fff;border:1px solid var(--line);border-radius:10px;padding:16px 20px;margin-bottom:20px;gap:12px;flex-wrap:wrap;z-index:auto;}
  && a{color:var(--accent);font-size:13px;text-decoration:none;}
  && button{min-height:38px;}
  position: sticky;
  top: 0;
  background-color: #313E4F;
  padding: 12px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  @media(max-width:768px){padding:12px 16px;gap:.75rem;flex-wrap:wrap;}
`;

// 왼쪽 설치 버튼 영역
export const InstallButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 14px;

  img {
    width: 20px;
    height: 20px;
  }

  &:hover {
    opacity: 0.9;
  }
`;

// 오른쪽 호스트 추가 버튼
export const HostAddButton = styled.button`
  &&{background:var(--accent);border-radius:7px;padding:10px 14px;font-size:13px;}
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const Wrap = styled.div`
  &&{display:grid;grid-template-columns:repeat(auto-fill,minmax(min(100%,280px),1fr));padding:20px 0;gap:16px;align-items:stretch;overflow:visible;min-width:0;}
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 20px 40px;
  max-width: none;  // max-width 제거
  margin: 0;        // margin 제거
  align-items: flex-start;
  justify-content: flex-start;
  overflow: auto;
  @media(max-width:768px){padding:1rem;gap:1rem;overflow:visible;> *{max-width:100%;}}
`;
// 상단 컨테이너 스타일
export const TopContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  margin-bottom: 20px;
`;

// 호스트 추가 버튼 스타일 수정
export const HostAdd = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  background-color: #313E4F;
  border: none;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #212E3F;
  }
`;

// 클라이언트 설치 버튼 스타일 수정
export const ClientInstall = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 20px;
  color: white;
  background-color: #313E4F;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease-in-out;

  img {
    width: 24px;
    height: 24px;
  }

  &:hover {
    background-color: #212E3F;
  }
`;
export const InfraContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 70px;
  padding-top: 0px;

  > h1 {
    text-align: left;
    margin: 0;
  }
  @media(max-width:768px){padding:1rem;flex-wrap:wrap;gap:1rem;}
`;



export const HostInstall = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  ${HostAdd} {
    display: inline-flex;
  }
`;

export const AntsCloud = styled.button`
  width: 300px;
  height: 50px;
  color: white;
  padding-right: 35px;
  padding-left: 0;
  margin-right: 2%;
  font-size: 16px;
  white-space: nowrap;
  text-decoration: none;
  border-radius: 50px;
  background-color: #313E4F;
  border: none;
  display: flex;
  align-items: center;

  &:hover {
    background-color: #212E3F;
  }
  @media(max-width:768px){width:100%;max-width:100%;margin-right:0;padding-right:1rem;white-space:normal;}
`;

export const Anchor = styled.a`
  text-decoration: none;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Tab = styled.button`
  width: 400px;
  height: 70px;
  padding: 20px 20px;
  cursor: pointer;
  border: none;
  background-color: #f5f5f5;
  margin-right: 15px;
  margin-top: 50px;
  border-radius: 5px;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.1);
  position: relative;
  @media(max-width:768px){width:100%;height:auto;min-height:60px;margin:0 0 .75rem;padding:1rem;}
`;



//[컴포넌트 탭 구성
function SkynetContent(props) {
  const [cloud_host, set_cloud_host] = useRecoilState(InfraListAtom);
  useEffect(() => {
    let active = true;
    set_cloud_host([]);
    reqGet('api/cloud_host', { type: props.type }, (result) => {
      if(active) set_cloud_host(Array.isArray(result)?result:[])
    });
    return () => { active = false; };
  }, [props.type, set_cloud_host]);
  return (
    <div>
      {/* Skynet에 관한 내용 */}
      <Wrap>
        {cloud_host != [] && cloud_host.map((host, idx) => (
          <RemoteCard key={idx}
            type={props.type}
            infra_id={host.infra_id}
            title={host.infra_title}
            domain={host.infra_domain}
            port={host.infra_port}
            info={host.infra_info}
            defaultAccount={host.default_account}
            os_type={host.os_type}
            console_proto={host.console_proto}
            flag={host.infra_flag}
            editMode={false}
            remove={props.remove}
            refresh={()=>{
              reqGet('api/cloud_host', { type: props.type }, (result) => {
                set_cloud_host(Array.isArray(result)?result:[])
              });
            }}
          />
        ))}
      </Wrap>
    </div>
  );
}

function AWSContent(props) {
  const [cloud_host, set_cloud_host] = useRecoilState(InfraListAtom);
  useEffect(() => {
    let active = true;
    set_cloud_host([]);
    reqGet('api/cloud_host', { type: props.type }, (result) => {
      if(active) set_cloud_host(Array.isArray(result)?result:[])
    });
    return () => { active = false; };
  }, [props.type, set_cloud_host]);
  return (
    <div>
      {cloud_host.length>0&&!cloud_host.some(host=>props.provider==='all'||host.infra_type===props.provider)&&<p className="compute-category-note">이 공급사에 등록된 서버가 없습니다.</p>}
      <Wrap>
        {cloud_host.filter(host=>props.provider==='all'||host.infra_type===props.provider).map((host) => (
          <div key={host.infra_id}><div className="compute-provider-label">{providerLabel(host.infra_type||'External')}</div><RemoteCard
            type={host.infra_type||'External'}
            infra_id={host.infra_id}
            title={host.infra_title}
            domain={host.infra_domain}
            port={host.infra_port}
            info={host.infra_info}
            defaultAccount={host.default_account}
            os_type={host.os_type}
            console_proto={host.console_proto}
            flag={host.infra_flag}
            editMode={false}
            remove={props.remove}
            refresh={()=>{
              reqGet('api/cloud_host', { type: props.type }, (result) => {
                set_cloud_host(Array.isArray(result)?result:[])
              });
            }}
          /></div>
        ))}
       </Wrap>
    </div>
  );
}


function AntsNestContent(props) {
  const [cloud_host, set_cloud_host] = useRecoilState(InfraListAtom);
  useEffect(() => {
    reqGet('api/cloud_host', { type: props.type }, (result) => {
      console.log(JSON.stringify(result));
      set_cloud_host(result)
    });
  }, []);
  return (
    <div>

<Wrap>
        {cloud_host != [] && cloud_host.map((host, idx) => (
          <RemoteCard key={idx}
            type={props.type}
            infra_id={host.infra_id}
            title={host.infra_title}
            domain={host.infra_domain}
            port={host.infra_port}
            info={host.infra_info}
            defaultAccount={host.default_account}
            editMode={false}
            flag={host.infra_flag}
            remove={props.remove}
            refresh={()=>{
              reqGet('api/cloud_host', { type: props.type }, (result) => {
                console.log(JSON.stringify(result));
                set_cloud_host(result)
              });
            }}
          />
        ))}

        {/* 데스크톱 창 */}
        <RemoteCard
          title="DataBase-Active"
          domain="net.antsnest.co.kr"
          ip="183.98.124.19"
          port="2002"
          adminPort=""
          info="엑티브 데이터베이스 서버"
          options={[
            { label: "OperationService", value: '1' },
            { label: "remote_guest", value: '2' },
            { label: "DataBase", value: '3' },
            { label: "DataBase_Active", value: '4' }
          ]}
        />

        <RemoteCard
          title="DataBase-StandBy"
          domain="net.antsnest.co.kr"
          ip="183.98.124.19"
          port="7070"
          adminPort="1007"
          info="스텐바이 데이터베이스 서버"
          options={[
            { label: "OperationService", value: '1' },
            { label: "remote_guest", value: '2' },
            { label: "DataBase-StandBy", value: '3' },
            { label: "DataBase_StandBy", value: '4' }]}
        />

        <RemoteCard
          title="Skynet-Master"
          domain="play.antsnest.co.kr"
          ip="220.76.52.213"
          port="2020"
          adminPort="1007"
          info="앤츠네스트 운영 마스터 서버"
          options={[
            { label: "OperationService", value: '1' },
            { label: "Skynet_Master", value: '2' }]}
          urlConnect="antsrdp://play.antsnest.co.kr:2020$OperationService$"
          accountUrlConnect="antsrdp://play.antsnest.co.kr:2020$"
        />

        <RemoteCard
          title="Skynet-Slave"
          domain="play.antsnest.co.kr"
          ip="220.76.52.213"
          port="2002"
          adminPort="1004"
          info="앤츠네스트 운영 슬레이브 서버"
          options={[
            { label: "OperationService", value: '1' },
            { label: "Skynet_Slave", value: '2' },
            { label: "remote_guest", value: '3' }]}
          urlConnect="antsrdp://play.antsnest.co.kr:2002$OperationService$"
          accountUrlConnect="antsrdp://play.antsnest.co.kr:2002$$"
        />

        <RemoteCard
          title="M.Skynet-Master"
          domain="web.antsnest.co.kr"
          ip="14.52.219.9"
          port="7777"
          adminPort=""
          info="모바일 스카이넷 구축 테스트 마스터 서버"
          options={[
            { label: "OperationService", value: '1' },
            { label: "remote_guest", value: '2' }]}
          urlConnect="antsrdp://web.antsnest.co.kr:7777$OperationService$"
          accountUrlConnect="antsrdp://web.antsnest.co.kr:7777$$"
        />

        <RemoteCard
          title="M.Skynet-Slave"
          domain="web.antsnest.co.kr"
          ip="14.52.219.9"
          port="5000"
          adminPort=""
          info="모바일 스카이넷 구축 테스트 슬레이브 서버"
          options={[
            { label: "OperationService", value: '1' },
            { label: "u", value: '2' }]}
          urlConnect="antsrdp://web.antsnest.co.kr:5000$OperationService$"
          accountUrlConnect="antsrdp://web.antsnest.co.kr:5000$$"
        />

        <RemoteCard
          title="Skynet-GateWay"
          domain="net.antsnest.co.kr"
          ip="183.98.124.19"
          port="3389"
          adminPort=""
          info="앤츠네스트 관리자 페이지 및 라우팅 기능 서버"
          options={[
            { label: "OperationService", value: '1' },
            { label: "remote_guest", value: '2' },
            { label: "Skynet-GateWay", value: '3' }]}
          urlConnect="antsrdp://net.antsnest.co.kr:3389$OperationService$"
          accountUrlConnect="antsrdp://net.antsnest.co.kr:3389$$"
        />

        <RemoteCard
          title="Skynet-Info"
          domain="net.antsnest.co.kr"
          ip="121.138.68.87"
          port="3389"
          adminPort=""
          info="응용 개발 테스트 서버"
          options={[
            { label: "OperationService", value: '1' },
            { label: "remote_guest", value: '2' }]}
          urlConnect="antsrdp://net.antsnest.co.kr:3389$OperationService$"
          accountUrlConnect="antsrdp://net.antsnest.co.kr:3389$$"
        />

        <RemoteCard
          title="NodeMaster-Mst"
          domain="office.antsnest.co.kr"
          ip="121.138.68.87"
          port="1001"
          adminPort="2004"
          info="Master"
          options={[
            { label: "OperationService", value: '1' },
            { label: "remote_guest", value: '2' },
            { label: "NodeMaster_Mst", value: '3' }]}
          urlConnect="antsrdp://office.antsnest.co.kr:1001$OperationService$"
          accountUrlConnect="antsrdp://office.antsnest.co.kr:1001$$"
        />

        <RemoteCard
          title="NodeMaster-Slv"
          domain="office.antsnest.co.kr"
          ip="121.138.68.87"
          port="1002"
          adminPort="2007"
          info="Slave"
          options={[
            { label: "OperationService", value: '1' },
            { label: "remote_guest", value: '2' },
            { label: "NodeMaster_Slv", value: '3' }]}
          urlConnect="antsrdp://office.antsnest.co.kr:1002$OperationService$"
          accountUrlConnect="antsrdp://office.antsnest.co.kr:1002$$"
        />

        <RemoteCard
          title="Developer-Web"
          domain="web.antsnest.co.kr"
          ip="14.52.219.9"
          port="3389"
          adminPort=""
          info="스케일링 서버- 웹 개발test / test게이트웨이"
          options={[
            { label: "OperationService", value: '1' },
            { label: "remote_guest", value: '2' },
            { label: "Developer_Web", value: '3' }]}
          urlConnect="antsrdp://web.antsnest.co.kr:3389$OperationService$"
          accountUrlConnect="antsrdp://web.antsnest.co.kr:3389$$"
        />

        <RemoteCard
          title="Developer-App"
          domain="net.antsnest.co.kr"
          ip="183.98.124.19"
          port="9000"
          adminPort=""
          info="응용 개발 테스트 서버"
          options={[
            { label: "OperationService", value: '1' },
            { label: "remote_guest", value: '2' }]}
          urlConnect="antsrdp://net.antsnest.co.kr:9000$OperationService$"
          accountUrlConnect="antsrdp://net.antsnest.co.kr:9000$$"
        />
        <RemoteCard
          title="Skynet-Admin"
          domain="play.antsnest.co.kr"
          ip="220.76.52.213"
          port="3389"
          adminPort=""
          info="앤츠네스트 GPU 원격 서버"
          options={[
            { label: "OperationService", value: '1' },
            { label: "remote_guest", value: '2' }]}
          urlConnect="antsrdp://play.antsnest.co.kr:3389$OperationService$"
          accountUrlConnect="antsrdp://play.antsnest.co.kr:3389$$"
        />

        <RemoteCard
          title="Skynet-info"
          domain="info.antsnest.co.kr"
          ip="121.138.68.87"
          port="3389"
          adminPort=""
          info="스카이넷 정보포탈"
          options={[
            { label: "OperationService", value: '1' },
            { label: "remote_guest", value: '2' }]}
          urlConnect="antsrdp://info.antsnest.co.kr:3389$OperationService$"
          accountUrlConnect="antsrdp://info.antsnest.co.kr:3389$$"
        />
       </Wrap>
    </div>
  );
}




export default function Compute() {
  //[Components State========================================]//
  const [activeTab, setActiveTab] = useState('Skynet');
  const [cloud_host, set_cloud_host] = useRecoilState(InfraListAtom);
  const [activeProvider, setActiveProvider] = React.useState("skynet");
  const [externalProvider,setExternalProvider]=useState('all');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showVpcImport, setShowVpcImport] = useState(false);
  const selectTab = (tabName) => {
    setActiveTab(tabName);
  }

  // 활성 탭 → infra_type 매핑 (소문자 provider id → 대문자 type)
  const providerToType = { skynet: 'Skynet', external: externalProvider==='all'?'External':externalProvider };
  const currentType = providerToType[activeProvider] || 'Skynet';

  // 호스트 목록 새로고침
  const refreshHosts = () => {
    reqGet('api/cloud_host', { type: activeProvider==='external'?'External':currentType }, (result) => {
      set_cloud_host(Array.isArray(result) ? result : []);
    });
  };

  // 모달 열기
  const openAddHost = () => setShowAddModal(true);

  // 마운트 시 placeholder 잔존 상태 정리 (이전 버전 addDesktopWindow 잔재)
  useEffect(() => {
    if (Array.isArray(cloud_host) && cloud_host.some(h => !h?.infra_id)) {
      set_cloud_host(cloud_host.filter(h => h?.infra_id));
    }
    // eslint-disable-next-line
  }, []);
  

    /**삭제 */
    const DeleteRemote = (infra_id, title) => {
      const label = title ? `"${title}" 호스트를 정말 삭제하시겠습니까?\n(이 작업은 되돌릴 수 없습니다)`
                          : `호스트(id=${infra_id})를 정말 삭제하시겠습니까?`;
      if (!window.confirm(label)) return;

      fetch(`/api/hostDelete`, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: infra_id })
      }).then((res) => {
        if (!res.ok) {
          throw new Error(`Server responded with status code ${res.status}`);
        }
        return res.text().then(t => t ? JSON.parse(t) : null);
      })
        .then(() => {
          const index = cloud_host.findIndex(item => item.infra_id === infra_id);
          if (index !== -1) {
            var newArray=[...cloud_host];
            newArray.splice(index, 1);
            set_cloud_host(newArray);
          }
        })
        .catch(err => alert('삭제 실패: ' + (err.message || err)));
    }
  
    const providers = [
      { id: "skynet", name: "스카이넷 자산" },
      { id: "external", name: "외부 클라우드" },
    ];

    return (
      <PageContainer className="compute-page">
        <Header/>
         <InstallBanner>
          <a href="/deploy#agent-onboarding">Ubuntu 표준 노드 설정 →</a>
          <InstallButton as="div">
            <Anchor href={ServiceInstaller} download="ServiceInstaller.msi">
              <img src={logo111} alt="Logo" />
              앤츠 클라우드 클라이언트 설치
            </Anchor>
          </InstallButton>
          <HostAddButton onClick={() => setShowVpcImport(true)} style={{ background: '#0a5b56' }}>
            <Plus size={16} />
            <span>VPC에서 가져오기</span>
          </HostAddButton>
          <HostAddButton onClick={openAddHost}>
            <Plus size={16} />
            <span>{activeProvider==='skynet'?'보유 장비 등록':'외부 서버 등록'}</span>
          </HostAddButton>
        </InstallBanner>
        <NodeSetupGuide section="compute"/>
        <ProviderTabs
          providers={providers}
          activeProvider={activeProvider}
          onProviderChange={setActiveProvider}
        />
      <div>
        {activeProvider === 'skynet' && <><p className="compute-category-note">직접 보유한 PC·서버·장비를 등록합니다. IWINV·Hetzner 등 임대한 서버는 외부 클라우드에서 관리합니다.</p><SkynetContent type='Skynet' remove={DeleteRemote}/></>}
        {activeProvider === 'external' && <ExternalCloud provider={externalProvider} onProviderChange={setExternalProvider}><AWSContent type='External' provider={externalProvider} remove={DeleteRemote}/></ExternalCloud>}
      </div>

      <HostAddEditModal
        open={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSaved={refreshHosts}
        type={currentType}
      />
      <VpcImportModal
        open={showVpcImport}
        type={currentType}
        onClose={() => setShowVpcImport(false)}
        onImported={refreshHosts}
      />
      </PageContainer>
    );
}

// ── VPC 피어를 호스트로 가져오기 ──────────────────────────────
function vpcAuthHeaders(json) {
  const h = json ? { 'Content-Type': 'application/json' } : {};
  const t = sessionStorage.getItem('token') || localStorage.getItem('token');
  if (t) h['Authorization'] = `Bearer ${t}`;
  return h;
}

function VpcImportModal({ open, type, onClose, onImported }) {
  const [peers, setPeers] = useState([]);
  const [sel, setSel] = useState({});
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true); setSel({});
    fetch('/api/vpn/peers', { headers: vpcAuthHeaders(false), credentials: 'include' })
      .then(r => r.json()).then(d => setPeers(d.peers || []))
      .catch(() => setPeers([]))
      .finally(() => setLoading(false));
  }, [open]);

  if (!open) return null;

  const toggle = (id) => setSel(s => ({ ...s, [id]: !s[id] }));
  const chosen = peers.filter(p => sel[p.peer_id]);

  const importHosts = async () => {
    if (!chosen.length) { alert('가져올 장비를 선택하세요.'); return; }
    setBusy(true);
    try {
      for (const p of chosen) {
        const isWin = (p.os_type || '').toLowerCase().includes('win');
        await fetch('/api/hostAdd', {
          method: 'POST', mode: 'cors', credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            type,
            title: p.hostname || `vpc-${p.virtual_ip}`,
            domain: p.virtual_ip,
            port: isWin ? '3389' : '22',
            info: `VPC: ${p.mesh_name}`,
            defaultAccount: '',
            os_type: isWin ? 'windows' : (p.os_type || 'linux'),
            console_proto: isWin ? 'rdp' : 'ssh',
          }),
        });
      }
      onImported && onImported();
      onClose();
    } catch (e) {
      alert('가져오기 실패: ' + e.message);
    } finally { setBusy(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: '#fff', borderRadius: 12, width: 640, maxWidth: '92vw', maxHeight: '80vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb', fontWeight: 600, fontSize: 16 }}>
          VPC에서 컴퓨터 가져오기 <span style={{ fontSize: 12, color: '#94a3b8', fontWeight: 400 }}>· {type} 호스트로 등록</span>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0' }}>
          {loading ? <div style={{ padding: 24, textAlign: 'center', color: '#94a3b8' }}>불러오는 중…</div>
            : peers.length === 0 ? <div style={{ padding: 24, textAlign: 'center', color: '#94a3b8' }}>VPC에 가입된 장비가 없습니다. (네트워크 → VPC에서 에이전트 연결)</div>
            : peers.map(p => {
              const online = p.status === 'online';
              return (
                <label key={p.peer_id} style={{ display: 'grid', gridTemplateColumns: '28px 1.4fr 1fr .8fr 1fr', alignItems: 'center', gap: 8, padding: '10px 20px', borderBottom: '1px solid #f1f5f9', cursor: 'pointer' }}>
                  <input type="checkbox" checked={!!sel[p.peer_id]} onChange={() => toggle(p.peer_id)} />
                  <span style={{ fontWeight: 600, color: '#1e293b' }}>{p.hostname || '(이름없음)'}</span>
                  <code style={{ fontSize: 12, color: '#334155' }}>{p.virtual_ip}</code>
                  <span style={{ fontSize: 12, color: '#64748b' }}>{p.os_type || '-'}</span>
                  <span style={{ fontSize: 12, color: '#475569' }}>
                    <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', marginRight: 6, background: online ? '#22c55e' : '#cbd5e1' }} />
                    {online ? '온라인' : '오프라인'} · {p.mesh_name}
                  </span>
                </label>
              );
            })}
        </div>
        <div style={{ padding: '12px 20px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={onClose} style={{ padding: '8px 16px', borderRadius: 6, border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer' }}>취소</button>
          <button onClick={importHosts} disabled={busy || !chosen.length} style={{ padding: '8px 16px', borderRadius: 6, border: 'none', background: 'var(--accent)', color: '#fff', cursor: 'pointer', opacity: busy || !chosen.length ? .6 : 1 }}>
            {busy ? '등록 중…' : `${chosen.length}대 등록`}
          </button>
        </div>
      </div>
    </div>
  );
}

const TabsContainer = styled.div`
  width: 100%;
`;

const TabsList = styled.div`
  &&{height:48px;border-bottom:1px solid var(--line);gap:24px;margin:0 0 8px;}
  width: 100%;
  height: 64px;
  background-color: ${props => props.theme.background};
  border-bottom: 1px solid ${props => props.theme.border};
  display: flex;
`;

const TabsTrigger = styled.button`
  &&{flex:none;padding:0 2px;font-size:14px;color:var(--muted);font-weight:500;border-bottom:2px solid transparent;}
  &&[data-active="true"]{background:none;border-color:var(--accent);color:var(--accent);}
  flex: 1;
  height: 100%;
  font-size: 1.125rem;
  font-family: 'Pretendard', sans-serif; // 폰트 추가
  font-weight: 600; // 폰트 두께 추가
  background: none;
  border: none;
  cursor: pointer;
  
  &[data-active="true"] {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;
const PageContainer = styled.div`
  ${pageTheme}

  display: flex;
  flex-direction: column;
`;

export function ProviderTabs({ providers, activeProvider, onProviderChange }) {
  return (
    <TabsContainer>
      <TabsList>
        {providers.map((provider) => (
          <TabsTrigger
            key={provider.id}
            onClick={() => onProviderChange(provider.id)}
            data-active={activeProvider === provider.id}
          >
            {provider.name}
          </TabsTrigger>
        ))}
      </TabsList>
    </TabsContainer>
  );
}



const HeaderContainer = styled.header`
  &&{padding:0;margin:0 0 24px;border:0;background:transparent;}
  ${headerTheme}

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  background: white;
  border-bottom: 1px solid #eaeaea;
  @media(max-width:768px){padding:1rem;flex-wrap:wrap;gap:.75rem;}
`

const Title = styled.h1`
 ${titleTheme}

  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
`

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  @media(max-width:768px){width:100%;flex-wrap:wrap;gap:.5rem;> *{min-height:44px;}}
`

const LocationButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  background: white;
  font-size: 0.875rem;
  color: #1a1a1a;
  cursor: pointer;

  &:hover {
    background: #f9f9f9;
  }
`

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  background: white;
  @media(max-width:768px){flex:1;min-width:150px;}
`

const SearchInput = styled.input`
  border: none;
  outline: none;
  width: 200px;
  margin-left: 0.5rem;
  font-size: 0.875rem;
  @media(max-width:768px){width:100%;min-width:0;}

  &::placeholder {
    color: #999;
  }
`

const DeployButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #0066ff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.875rem;
  cursor: pointer;

  &:hover {
    background: #0052cc;
  }
`

export function Header() {
  return (
    <HeaderContainer>
      <div><span className="console-eyebrow">COMPUTE RESOURCES</span><Title>컴퓨트</Title><p style={{color:'var(--muted)',fontSize:14,margin:'8px 0 0'}}>서버를 등록하고 연결된 머신에 접속합니다.</p></div>
    </HeaderContainer>
  )
}
